import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthRoles } from 'src/app/auth/auth.types';
import { AuthService } from '../../auth/auth.service';
import { ActivatedRoute } from '@angular/router';

@Directive({
  selector: '[removeIfUnauthorizedDevMode]'
})
export class RemoveIfUnauthorizedDevMode {
    private hasView: boolean = false;
    constructor(private container: ViewContainerRef,
        private template: TemplateRef<any>,
        private _authService: AuthService,
        private route: ActivatedRoute) { }

  @Input() set removeIfUnauthorizedDevMode(p: { name: string, expectedVal: string, role: AuthRoles[] }) {
        let hasUrlParam = this.route.snapshot.queryParamMap.get(p.name) == p.expectedVal;
        let hasRole = this._authService.hasRole(p.role);
        if (hasUrlParam && hasRole && !this.hasView) {
            this.container.createEmbeddedView(this.template);
            this.hasView = true;
        } else if ((!hasUrlParam || !hasRole) && this.hasView) {
            this.container.clear();
            this.hasView = false;
        }
    }
}
